import React from 'react'

export default function NoPage() {
  return (
    <div className='flex justify-center items-center'>
        <h2><strong>Error-404</strong></h2>
        <p>No page found</p>
    </div>
  )
}
